import { gql } from "@apollo/client";
export default gql`
  mutation UsersEmailConfig($input: UsersEmailConfigInput!) {
    usersEmailConfig(input: $input) {
      message
    }
  }
`;
